// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/frontend/fonts","css/frontend/app"], () => (__webpack_require__("./resources/js/app.js")))
__webpack_require__.O(undefined, ["css/frontend/fonts","css/frontend/app"], () => (__webpack_require__("./resources/scss/app.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/frontend/fonts","css/frontend/app"], () => (__webpack_require__("./resources/scss/fonts.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
